import {
  Grid,
  MenuItem,
  Stack,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from "@mui/material";
import { t } from "i18next";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import InputField from "../../../components/InputField";
import AppLoader from "../../../components/apploader";
import GlobalButton from "../../../components/button";
import CustomContainer from "../../../components/container/CustomContainer";
import DashboardHeader from "../../../components/dashboardHeader";
import Label from "../../../components/label";
import { useSnackbar } from "../../../lib/context/snackbarContext";
import { CURRENCY } from "../../../lib/variables";
import {
  getAllCategories,
  getAllSubCategories,
} from "../../../services/categoriesFn";
import { createUserPackage } from "../../../services/userPackageApiFn";
import { renderSubTotal } from "../../../utils";
import { createUserPackageValidation } from "../../../utils/validation";
import CustomSelect from "./../../../components/select/index";
import { translateText } from "./../../../utils/translationService";
import AllProducts from "./AllProducts";
import SelectedPackageProducts from "./SelectedProduct";

const UserEcommerceAddEditPackagePage = () => {
  const navigate = useNavigate();
  const { showSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = useState(false);
  const [allCategories, setAllCategories] = useState([]);
  const [allSubCategories, setAllSubCategories] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [language, setLanguage] = useState("ro");
  const userData = useSelector((state) => state.userReducer.user);
  const { currentLanguage } = useSelector((state) => state.translationReducer);

  console.log(selectedProducts, "asdsakjdsjdksadjksadjksakj");

  const [inputvalues, setInputValues] = useState({
    name_en: "",
    name_ro: "",
    description_en: "",
    description_ro: "",
    categoryId: "",
    subCategoryId: "",
  });

  const [inputError, setInputError] = useState({
    name_en: false,
    name_ro: false,
    categoryId: false,
  });

  useEffect(() => {
    fetchCategories();
  }, []);

  const fetchCategories = async () => {
    try {
      setIsLoading(true);
      const response = await getAllCategories();
      if (response.data.status === "success") {
        setAllCategories(response.data.data);
      }
    } catch (error) {
      showSnackbar(error?.message || t("somethingWentWrong"));
    } finally {
      setIsLoading(false);
    }
  };

  const fetchSubCategories = async (value) => {
    try {
      setIsLoading(true);
      const response = await getAllSubCategories(value);
      if (response.data.status === "success") {
        let data = response.data.data;
        setAllSubCategories(data);
      }
    } catch (error) {
      showSnackbar(error?.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleChangeInputValues = (event) => {
    const { name, value } = event.target;

    if (name === "categoryId") {
      setInputValues((pre) => ({ ...pre, subCategoryId: "" }));
      fetchSubCategories(value);
      setSelectedProducts([]);
    }

    setInputError((pre) => ({
      ...pre,

      [name]: false,
    }));
    setInputValues((pre) => ({ ...pre, [name]: value }));
  };

  console.log(inputError, inputvalues, "HEYYYY");

  const handleAddEditPackage = async () => {
    // const hasError = createUserPackageValidation(inputvalues, setInputError);
    // if (hasError) {
    //   return;
    // }

    if (selectedProducts.length < 2)
      return showSnackbar(
        "Select atleast two products to create a package",
        "error"
      );

    if (!inputvalues.name_en?.trim())
      return showSnackbar(`Package name is required in English`, "error");
    if (!inputvalues.name_ro?.trim())
      return showSnackbar(`Package name is required in Roman}`, "error");

    const allImages = selectedProducts.map((x) => x.coverImage);
    const totalprice = parseInt(renderSubTotal(selectedProducts));
    // const calculateDiscount =

    const allSubCategoryIds = selectedProducts.flatMap(
      (product) => product.subCategoryId
    );

    console.log(allSubCategoryIds, "sdkjsadsakdsadjk");

    // Step 2: Duplicate hata ke unique banana
    const uniqueSubCategoryIds = [...new Set(allSubCategoryIds)];
    try {
      setIsLoading(true);
      const payload = {
        images: allImages,
        name: {
          en: inputvalues.name_en,
          ro: inputvalues.name_ro,
        },
        description: {
          en: inputvalues.description_en,
          ro: inputvalues.description_ro,
        },
        price: totalprice,
        finalPrice: totalprice,
        discount: 0,
        categoryId: inputvalues.categoryId,
        subCategoryId: uniqueSubCategoryIds,
        createdBy: userData?._id,
        products: selectedProducts,
      };
      // return;
      const response = await createUserPackage(payload);
      if (response.data.status === "success") {
        navigate(-1);
        showSnackbar(response.data.message, "success");
      } else {
        showSnackbar(response.data.message, "error");
      }
    } catch (error) {
      showSnackbar(error?.message, "error");
    } finally {
      setIsLoading(false);
    }
  };

  const handleChangeLanguage = (event, newLang) => {
    if (newLang !== null) {
      setLanguage(newLang);
    }
  };

  const renderHeader = () => {
    return (
      <Stack direction={"row"} alignItems={"center"} gap={1}>
        {language === "ro" && (
          <GlobalButton btnText={"Convert"} handleClickBtn={handleConvert} />
        )}

        <ToggleButtonGroup
          value={language}
          exclusive
          onChange={handleChangeLanguage}
          aria-label="language selection"
        >
          <ToggleButton value="ro" aria-label="romanian" size="small">
            Ro
          </ToggleButton>
          <ToggleButton value="en" aria-label="english" size="small">
            En
          </ToggleButton>
        </ToggleButtonGroup>
      </Stack>
    );
  };

  const handleConvert = async () => {
    setIsLoading(true);

    try {
      const [nameTranslation, descTranslation] = await Promise.all([
        translateText(inputvalues.name_ro),
        translateText(inputvalues.description_ro),
      ]);
      setInputValues((prev) => ({
        ...prev,
        name_en: nameTranslation,
        description_en: descTranslation,
      }));
    } catch (error) {
      showSnackbar(
        error?.message,
        "Something went wrong while converting language"
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <DashboardHeader>
      <AppLoader isVisible={isLoading} />
      <CustomContainer
        primaryHeading={t("createEcommercePackage")}
        secondaryHeading={t("addEcommercePackage")}
        headProps={renderHeader()}
        showBackButton={true}
        handleBack={() => navigate("/dashboard/ecommerce-package")}
      >
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <Label text={t("selectCategory")} required htmlFor="category_id" />
            <CustomSelect
              id="category_id"
              name="categoryId"
              value={inputvalues.categoryId}
              onChange={handleChangeInputValues}
              selectError={inputError.categoryId}
              helperText={inputError.categoryId && t("selectAnyCategory")}
              formStyleProps={{
                "& .MuiSelect-outlined": {
                  padding: "8px !important",
                  textTransform: "capitalize",
                },
              }}
              MenuProps={{
                PaperProps: {
                  style: {
                    maxHeight: 300,
                    overflowY: "auto",
                  },
                },
              }}
            >
              <MenuItem value="">{t("selectCategory")}</MenuItem>
              {allCategories.map((x) => (
                <MenuItem
                  key={x._id}
                  value={x._id}
                  sx={{ textTransform: "capitalize" }}
                >
                  {x.name[language]}
                </MenuItem>
              ))}
            </CustomSelect>
          </Grid>
          <Grid item xs={12} md={6}>
            <Label
              text={t("selectAnyCategory")}
              required
              htmlFor="subcategory_id"
            />
            <CustomSelect
              id="subcategory_id"
              name="subCategoryId"
              value={inputvalues.subCategoryId}
              onChange={handleChangeInputValues}
              formStyleProps={{
                "& .MuiSelect-outlined": {
                  padding: "8px !important",
                  textTransform: "capitalize",
                },
              }}
              MenuProps={{
                PaperProps: {
                  style: {
                    maxHeight: 300,
                    overflowY: "auto",
                  },
                },
              }}
            >
              <MenuItem value="">{t("selectAnyCategory")}</MenuItem>
              {allSubCategories.map((x) => (
                <MenuItem
                  key={x._id}
                  value={x._id}
                  sx={{ textTransform: "capitalize" }}
                >
                  {x.name[language]}
                </MenuItem>
              ))}
            </CustomSelect>
          </Grid>

          <Grid item xs={12}>
            <AllProducts
              language={language}
              categoryId={inputvalues.categoryId}
              subCategoryId={inputvalues.subCategoryId}
              selectedProducts={selectedProducts}
              setSelectedProducts={setSelectedProducts}
            />
          </Grid>

          {selectedProducts.length > 0 && (
            <Grid item xs={12}>
              <Typography variant="h6" mb={2} textTransform={"capitalize"}>
                {t("selectedProducts")}
              </Typography>
              <Grid container spacing={2}>
                {selectedProducts?.map((val, index) => {
                  return (
                    <Grid key={index} item xs={12} sm={4} md={3}>
                      <SelectedPackageProducts
                        language={language}
                        product={val}
                        index={index}
                        selectedProducts={selectedProducts}
                        setSelectedProducts={setSelectedProducts}
                      />
                    </Grid>
                  );
                })}
              </Grid>
            </Grid>
          )}
          <Grid item xs={12}>
            <Label
              text={`${t("nameYourPackage")} in ${language.toUpperCase()}`}
              required
              htmlFor="package_name"
            />
            <InputField
              id={"package_name"}
              required
              placeholder={`${t("enter")} ${t(
                "firstName"
              )} in ${language.toUpperCase()}`}
              type="text"
              name={`name_${language}`}
              value={inputvalues[`name_${language}`]}
              onChange={handleChangeInputValues}
            />
            <Label
              text={t("packageNameNote", { language: language })}
              labelProps={{
                fontSize: "0.75rem",
                textTransform: "none",
                mt: 0.5,
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <Label
              text={`${t("addDescription")} in ${language.toUpperCase()}`}
              htmlFor="description"
            />
            <InputField
              id={"description"}
              required
              placeholder={t("enterPackageDescription")}
              type="text"
              multiline
              rows={4}
              name={`description_${language}`}
              value={inputvalues[`description_${language}`]}
              onChange={handleChangeInputValues}
            />
          </Grid>

          {/* <Grid item xs={12}>
            <Label text={t("addSpecification")} required htmlFor="user-fname" />
            <CustomEditor
              error={inputError.specification}
              errorText={t("specificationRequired")}
              text={inputvalues.specification}
              handleEditorChange={(event, editor) => {
                const data = editor.getData();
                setInputError((pre) => ({ ...pre, specification: false }));
                setInputValues((pre) => ({ ...pre, specification: data }));
              }}
            />
          </Grid> */}
        </Grid>

        <footer>
          <Stack
            p={2}
            mt={2}
            direction={"row"}
            alignItems={"center"}
            justifyContent={"flex-end"}
            borderRadius={1}
          >
            <GlobalButton
              btnText={`${t("createPackage")}  ${t(
                "totalPrice"
              )}: ${CURRENCY} ${renderSubTotal(selectedProducts) || 0}`}
              styleProps={{ width: "auto" }}
              disabled={selectedProducts?.length === 0}
              handleClickBtn={handleAddEditPackage}
            />
          </Stack>
        </footer>
      </CustomContainer>
    </DashboardHeader>
  );
};

export default UserEcommerceAddEditPackagePage;
